export default {
  // ADMIN_API: 'http://192.168.6.215:7001',
  ADMIN_API: 'https://supbricks.com',
  // ADMIN_API: 'https://test.gobricks.cn',
  // WEBAPP_HOST: 'https://test.gobricks.cn',
  // WEBAPP_HOST: 'http://192.168.6.215:7001',
  WEBAPP_HOST: 'https://supbricks.com'
}



// WEBPACK FOOTER //
// ./src/api/config.js